// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables() {
  
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"currentlyLoggedInAgent":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"currentlyLoggedInAgent":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "UnifiedProfileImage",
  "kind": "LinkedField",
  "name": "unifiedFeaturedPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "width",
          "value": 720
        }
      ],
      "kind": "ScalarField",
      "name": "url",
      "storageKey": "url(width:720)"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedYourProfilePhotosSettingsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Agent",
          "kind": "LinkedField",
          "name": "currentlyLoggedInAgent",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfilePhoto",
              "kind": "LinkedField",
              "name": "profilePhoto",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            (v1/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProfilePageProfilePhotoForm_agent"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "UnifiedYourProfilePhotosSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Agent",
        "kind": "LinkedField",
        "name": "currentlyLoggedInAgent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfilePhoto",
            "kind": "LinkedField",
            "name": "profilePhoto",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": "photoUrl",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "ratio",
                    "variableName": "__relay_internal__pv__DevicePixelRatio"
                  },
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 96
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e62030d5edfa91267a9a98498d31076f",
    "id": null,
    "metadata": {},
    "name": "UnifiedYourProfilePhotosSettingsQuery",
    "operationKind": "query",
    "text": "query UnifiedYourProfilePhotosSettingsQuery(\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  currentlyLoggedInAgent {\n    profilePhoto {\n      id\n    }\n    unifiedFeaturedPhoto {\n      url(width: 720)\n    }\n    ...ProfilePageProfilePhotoForm_agent\n    nodeId\n  }\n}\n\nfragment ProfilePageProfilePhotoForm_agent on Agent {\n  ...SharingProfileMiniFormProfilePhoto_agent\n}\n\nfragment SharingProfileMiniFormProfilePhoto_agent on Agent {\n  firstName\n  displayName\n  ...SharingProfileMiniFormProfilePhoto_currentPhoto_agent\n  ...SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent\n}\n\nfragment SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent on Agent {\n  id\n  profilePhoto {\n    __typename\n  }\n}\n\nfragment SharingProfileMiniFormProfilePhoto_currentPhoto_agent on Agent {\n  profilePhoto {\n    photoUrl: url(width: 96, ratio: $__relay_internal__pv__DevicePixelRatio)\n    id\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
